import getUaParam, {IUaParam} from '@/utils/getUaParam'
import {requestFreezeEquity} from '@/service/bookList'
import {APIError, isQRCodeError, isWritingError} from '@/constants/error'
import {haboClickReport} from '@/plugins/habo'
import {WritingError} from './components/WritingError'
import {ErrorType} from '.'

const getErrorInfoFromCode = (code: number, uaParam: IUaParam, message?: string) => {
    const {isXinliApp} = uaParam
    let type: ErrorType = 'error'
    let showBtn = false
    let description
    let onMounted
    let component: React.ReactElement | null = null

    if ([APIError.bookOffline, APIError.bookItemOffline].includes(code)) {
        type = 'offline'
    }
    else if (code === APIError.noVideo) {
        type = 'offline'
        description = '资料准备中，敬请期待'
    }
    else if (code === APIError.noSupportType) {
        type = 'null'
        description = '暂不支持该种题型'
    }
    else if (code === APIError.noLogin) {
        type = 'empty'
        description = '未登录无法使用哦，快去登录吧~'
    }
    else if (code === APIError.noChildQuestion) {
        type = 'empty'
        description = '题目有错误，请联系客服解决'
    }
    else if (code === APIError.questionDeleted) {
        type = 'empty'
        description = '抱歉，题目被删除，请联系客服解决'
    }
    else if (isWritingError(code)) {
        type = 'error'
        description = '哎呀！作文批改出错了'
        component = <WritingError />
        onMounted = () => {
            haboClickReport('批改结果_报错页面浏览')
        }
    }
    else if (isQRCodeError(code)) {
        type = 'empty'
        description = '老师没有配置内容，请联系客服处理'
    }
    else if (code === APIError.writingEmptyError) {
        type = 'error'
        description = '作文批改次数已用尽'
    }
    else if (code === APIError.writingDisabled) {
        type = 'error'
        description = '作文批改模块暂不可用'
    }
    else if (code === APIError.equityFrozen) {
        type = 'offline'
        description = isXinliApp ? '该图书权益已冻结，如有问题请在APP我的页联系客服' : '该图书权益已冻结，如有问题请在APP主页右上角联系客服'
        onMounted = () => {
            const {equityNumber} = getUaParam()
            requestFreezeEquity(equityNumber)
        }
    }
    else if (code === APIError.ownershipChange) {
        type = 'error'
        description = message || '抱歉，因图书归属发生变化，请联系客服解决'
    }
    // else {
    //     showBtn = true
    // }

    return {
        type,
        showBtn,
        description,
        onMounted,
        component,
    }
}

export default getErrorInfoFromCode
